type HeadlineProps = {
    text: string;
    id?: string;
};
/**
 * A card headline
 */
const Headline = ({ id, text }: HeadlineProps) => {
    return (
        <h3
            className="headline"
            id={id}
            data-cy="headline"
            data-testid="headline-3"
        >
            {text}
        </h3>
    );
};

export default Headline;
